export * from './generic-form.component';



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/index.ts